import { Modal } from 'antd';
import './style.scss';
import CustomButton from '../../../../../../../../v2-components/Antd/Button';

const DeliveryModal = ({ visible, onCancel, onAccept, deliveryType }) => {
	const getModalContent = () => {
		if (deliveryType === 'pharmacy') {
			return (
				<div>
					<h3>Los retiros en farmacia</h3>
					<ul>
						<li>Se realizan de lunes a viernes de 9:30 a 18:00 hs.</li>
						<li>Se notificará por WhatsApp cuando esté disponible para retiro.</li>
					</ul>
				</div>
			);
		} else if (deliveryType === 'delivery') {
			return (
				<div>
					<h3>Los envíos a domicilio</h3>
					<ul>
						<li>Comunas de Santiago se entregan entre las 17:00 y 22:00 hrs.</li>
						<li>⁠Regiones (incluida la Metropolitana) Los realiza Correos de Chile entre 24 y 48 horas. En caso de que no llegue a tu domicilio, nos contactaremos para indicar la sucursal de retiro.</li>
					</ul>
				</div>
			);
		}
		return null; // En caso de que no sea ni 'pharmacy' ni 'delivery'
	};

	const title = deliveryType === 'pharmacy' ? 'Retiro en farmacia' : 'Envío a domicilio';

	return (
		<Modal
			title={title}
			visible={visible}
			onCancel={onCancel}
			footer={[
				<CustomButton key="accept" className="ph-btn ph-btn--accept" onClick={onAccept}>
					Aceptar
				</CustomButton>,
			]}
			className="delivery-modal" 
		>
			{getModalContent()}
		</Modal>
	);
};

export default DeliveryModal;
